<template>
  <div>
    <van-sticky>
      <van-nav-bar
        :title="$route.query.title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>
    <div style="margin: 10px;text-align: center"><h4>俱乐部总人数:{{ count }}</h4>
      <h4>今日本俱乐部场馆预约数:{{ vCount }}</h4>

      今日场馆预约率
      <van-circle layer-color="#ebedf0" v-model="currentRate" :rate="rate" :speed="25" :text="text"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar,
  Sticky,
  Circle,
} from 'vant';

Vue.use(NavBar);
Vue.use(Sticky);
Vue.use(Circle);
import {GetStatisticsById} from "@/network/club";

export default {
  name: "ClubStatistics",
  data() {
    return {
      count: 0,
      vCount: 0,
      currentRate: 0,

      years: 0,
      months: 0,
      days: 0,
    }
  },
  activated() {
    let now = new Date();
    this.years = now.getFullYear();
    this.months = now.getMonth() + 1;
    this.days = now.getDate();
    this.getVenueLists();
  },
  computed: {
    text() {
      return this.currentRate.toFixed(0) + '%';
    },
    rate() {
      this.currentRate = this.vCount * 100 / this.count
      return this.currentRate;
    }
  },

  methods: {
    onClickLeft() {
      this.$router.replace("ClubList");
    },
    getVenueLists() {
      GetStatisticsById(this.$route.query.cid, this.years, this.months, this.days).then(res => {
        this.count = parseInt(res.count);
        this.vCount = parseInt(res.v_count);

      })
    },
  }
}
</script>

<style scoped>

</style>
